module.exports = function() {
  return new Worker(__webpack_public_path__ + "29c63780646be6bf2bda.worker.js");
};